import { Chip } from '@mui/material';

import { translate } from '@/ui/i18n';

export function CustomAvgCapacityTag({
  avgCapacity,
  onClick,
  disabled,
}: {
  avgCapacity: number;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <Chip
      label={`${translate('VenueDates.QuizPanel.custom-avg-capacity')} : ${avgCapacity}`}
      size="small"
      onClick={onClick}
      disabled={disabled}
      sx={{
        alignSelf: 'center',
        fontWeight: 600,
        fontSize: '1rem',
        cursor: onClick ? 'pointer' : 'default',
      }}
    />
  );
}
